<input type="file" #fileUpload style="display: none" [accept]="accept" (change)="uploadFile()" />
